<template>
    <div class="about content">
        <div class="bread">
            <bread :data="[{path: '/about', title: '关于我们'}]"></bread>
        </div>

        <card class="types">
            <span slot="title">
                关于我们
            </span>
            <!--
            <tab-btn
                :data="types"
                v-model="type"
            ></tab-btn>-->
        </card>

        <card class="main-con">
            <div 
                class="rich-text" 
                v-html="richPreHandler(detail.infocontent)"
            ></div>
        </card>
    </div>
</template>

<script>
import Card from '@components/sys/card';
import List from '@components/sys/list';
import Bread from '@components/sys/bread';
import TabBtn from '@components/sys/tab-btn';

import CONFIG from '@config/config';

export default {
    components: {
        Card,
        List,
        Bread,
        TabBtn,
    },
    data: () => ({
        type: 'about',

        detail: '',
    }),
    methods: {
        queryAbout() {
            var that = this;
     
            that.$get(`${this.$store.state.api.webUrl}/index/information/getwebinfounion.json`,{
                maxrow:1,
                featurecode:CONFIG.head.planname,
                categoryids:'105'
            }, data => {
                if(data){
                    that.detail = data;
                }
            });
        },
        richPreHandler(html) {
            if (!html) return '';

            var res = html;

            res = res.replace(/&nbsp;/g, '');

            return res;
        },
        
    },
    mounted() {
        this.queryAbout();
    },
}
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.about{
    margin-bottom: 26px;

    .types{
        margin-bottom: 12px;

        .type-sel{
            overflow: hidden;

            .item{
                float: left;
                font-size: 16px;
                line-height: 1em;
                padding: 8px 10px;
                border-radius: 18px;
                border: 1px solid #d6d6d6;
                cursor: pointer;

                & + .item{
                    margin-left: 1em;
                }

                &.active{
                    color: white;
                    background: $primaryColor;
                    border-color: $primaryColor;
                }
            }
        }
    }

    .main-con{
        min-height: 700px;
    }

    .page{
        margin-top: 1em;
    }
}
</style>
